<template>
  <div>
    <c-search-box @enter="getSearchList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="edit" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-dept
            type="search"
            name="deptCd"
            label="관리부서"
            v-model="searchParam.deptCd"
          ></c-dept>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-line
            type="search"
            name="lineCd"
            label="라인"
            :deptCd="searchParam.deptCd"
            v-model="searchParam.lineCd"
          ></c-line>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="사용여부"
            v-model="searchParam.useFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
        <!-- 공정 목록 -->
        <c-table
          ref="processTable"
          title="LBL0001702"
          :columns="grid.columns"
          :data="grid.data"
          :merge="grid.merge"
          :columnSetting="false"
          :isFullScreen="false"
          :usePaging="false"
          :expandAll="true"
          @rowClick="rowClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <!-- 검색 -->
              <c-btn label="LBLSEARCH" icon="search" @btnClicked="getSearchList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
        <q-form ref="editForm">
          <!-- 공정상세 -->
          <c-card :title="title" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <!-- 신규 공정 -->
                <c-btn v-if="editable" label="LBL0003232" icon="add" @btnClicked="addParent" />
                <!-- 신규 단위공정 -->
                <!-- <c-btn v-if="editable && this.data.processLevelCd == '10' && selectedProcessCd" label="LBL0003245" icon="add" @btnClicked="addChild" /> -->
                <!-- 삭제 -->
                <c-btn v-if="editable && dataeditable && selectedProcessCd" label="LBLREMOVE" icon="remove" @btnClicked="removeProcess" />
                <!-- 저장 -->
                <c-btn
                  v-if="editable && dataeditable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="data"
                  :mappingType="saveType"
                  label="LBLSAVE"
                  icon="save"
                  @beforeAction="saveData"
                  @btnCallback="saveCallback" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-6">
                <!-- 공정명 -->
                <c-text
                  :editable="editable && dataeditable"
                  :required="true"
                  label="LBL0003230"
                  name="processName"
                  v-model="data.processName">
                </c-text>
              </div>
              <div class="col-3">
                <c-dept
                  type="edit"
                  :editable="editable && dataeditable"
                  :required="true"
                  name="managementDepts"
                  label="관리부서"
                  v-model="data.managementDepts"
                ></c-dept>
              </div>
              <div class="col-3">
                <c-line
                  type="edit"
                  :editable="editable && dataeditable"
                  name="lineCd"
                  label="라인"
                  :deptCd="data.managementDepts"
                  v-model="data.lineCd"
                ></c-line>
              </div>
              <div class="col-3">
                <!-- 사업장 -->
                <c-plant
                  :required="true"
                  :editable="editable && dataeditable"
                  label="LBLPLANT"
                  name="plantCd"
                  v-model="data.plantCd">
                </c-plant>
              </div>
              <div class="col-3">
                <!-- 정렬순서 -->
                <c-text
                  :editable="editable && dataeditable"
                  :required="true"
                  label="LBLSORTORDER"
                  name="orderNo"
                  v-model="data.orderNo">
                </c-text>
              </div>
              <div class="col-3">
                <c-checkbox
                  :editable="editable && dataeditable"
                  :isFlag="true"
                  label="PSM대상"
                  name="psmFlag"
                  v-model="data.psmFlag"
                />
              </div>
              <div class="col-3">
                <c-checkbox
                  :editable="editable && dataeditable"
                  :isFlag="true"
                  label="사용여부"
                  name="useFlag"
                  v-model="data.useFlag"
                />
              </div>
              <div class="col-12">
                <!-- 공정설명 -->
                <c-textarea
                  :counter="true"
                  :editable="editable && dataeditable"
                  label="LBL0003238"
                  name="processDesc"
                  :rows="2"
                  v-model="data.processDesc">
                </c-textarea>
              </div>
              <div class="col-12">
                <!-- 공정 사진 -->
                <c-upload
                  :attachInfo="attachInfoL1Photo"
                  :editable="editable && dataeditable"
                  label="LBL0003240">
                </c-upload>
              </div>
            </template>
          </c-card>
        </q-form>
      </div>
    </div>
  </div>
</template>

<script>
import { uid } from 'quasar'
import transactionConfig from '@/js/transactionConfig';
import selectConfig from '@/js/selectConfig';
export default {
  name: 'process-manage',
  data() {
    return {
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      searchParam: {
        plantCd: null,
        useFlag: 'Y',
        deptCd: '',
        lineCd: '',
      },
      grid: {
        merge: [
          { index: 0, colName: 'deptCd' },
          { index: 1, colName: 'lineCd' },
        ],
        columns: [
          {
            name: 'deptName',
            field: 'deptName',
            label: '관리부서',
            align: 'center',
            sortable: false,
            style: 'width: 140px',
          },
          {
            name: 'lineName',
            field: 'lineName',
            label: '라인명',
            align: 'left',
            style: 'width: 200px',
            sortable: false,
          },
          {
            name: 'processName',
            field: 'processName',
            // 공정명
            label: 'LBL0003230',
            align: 'left',
            sortable: false,
          },
          {
            name: 'orderNo',
            field: 'orderNo',
            // 순번
            label: 'LBLSORTORDER',
            align: 'center',
            style: 'width: 70px',
            sortable: false,
          },
          {
            name: 'useFlag',
            field: 'useFlag',
            // 사용여부
            label: '사용여부',
            align: 'center',
            style: 'width: 70px',
            sortable: false,
          },
        ],
        data: [],
      },
      listUrl: '',
      detailUrl: '',
      checkUrl: '',
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      saveable: false,
      deleteable: false,
      editable: true,
      dataeditable: false,
      updateMode: false,
      isSave: false,
      saveUrl: transactionConfig.mdm.process.insert.url,
      saveType: 'POST',
      selectedProcessCd: '',
      selectedProcess: null,
      attachInfoL1Photo: {
        isSubmit: '',
        taskClassCd: 'PROCESS_UP',
        taskKey: '',
      },
      attachInfoL2Photo: {
        isSubmit: '',
        taskClassCd: 'PROCESS_UNIT_PHOTO',
        taskKey: '',
      },
      attachInfoL1Hazard: {
        isSubmit: '',
        taskClassCd: 'PROCESS_UNIT_HAZARD',
        taskKey: '',
      },
      psmYnItems: [
        { code: 'Y', codeName: '대상' },
        { code: 'N', codeName: '해당없음' },
      ],
      data: {
        plantCd: null,
        processCd: '',
        processNo: '',
        processName: '',
        upProcessCd: '',
        upProcessName: '',
        processLevelCd: '',
        processDesc: '',
        managementDepts: '',
        lineCd: '',
        orderNo: '',
        mainMaterial: '',
        workerCnt: '',
        productName: '',
        useFlag: 'Y',
        psmFlag: 'N',
        workCycleCd: null,
        workingTime: null,
        temperature: '',
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    title() {
      return 'LBL0003231';
    },
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.mdm.process.list.url;
      this.detailUrl = selectConfig.mdm.process.get.url;
      this.checkUrl = selectConfig.mdm.process.check.url;
      this.insertUrl = transactionConfig.mdm.process.insert.url;
      this.updateUrl = transactionConfig.mdm.process.update.url;
      this.deleteUrl = transactionConfig.mdm.process.delete.url;
      this.getList();
    },
    rowRemoveSelect() {
      var _table = document.getElementsByClassName('bg-light-blue-1')[0];
      if (_table) {
        _table.classList.remove('bg-light-blue-1');
      }
    },
    getSearchList() {
      this.getList();
      this.reset();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    rowClick(row) {
      // 상세조회
      this.selectedProcess = row;
      this.selectedProcessCd = row.processCd;
      // 상세조회
      this.saveable = true;
      this.deleteable = true;
      this.rowNotSelected = false;
      this.updateMode = true;
      this.$http.url = this.$format(this.detailUrl, this.selectedProcessCd);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.data = _result.data;
        this.$set(this.attachInfoL1Photo, 'taskKey', row.processCd)
        this.$set(this.attachInfoL1Hazard, 'taskKey', row.processCd);
        this.$set(this.attachInfoL2Photo, 'taskKey', row.processCd);
        this.saveUrl = this.updateUrl;
        this.saveType = 'PUT';
        this.dataeditable = true;
      },
      () => {
      });
    },
    reset() {
      this.rowRemoveSelect();
      this.selectedProcessCd = '';
      this.selectedProcess = null;
      this.saveable = false;
      this.deleteable = false;
      this.updateMode = false;
      this.dataeditable = false;
      this.data = {
        plantCd: null,
        processCd: '',
        processNo: '',
        processName: '',
        upProcessCd: '',
        upProcessName: '',
        processLevelCd: '',
        processDesc: '',
        managementDepts: '',
        orderNo: '',
        mainMaterial: '',
        workerCnt: '',
        productName: '',
        useFlag: 'Y',
        psmFlag: 'N',
        workCycleCd: null,
        workingTime: null,
        temperature: '',
      };
      this.$set(this.attachInfoL1Photo, 'taskKey', '');
      this.$set(this.attachInfoL1Hazard, 'taskKey', '');
      this.$set(this.attachInfoL2Photo, 'taskKey', '');
    },
    saveData() {
      this.$refs['editForm'].validate().then(_result => {
        // 중복체크
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: 'MSGSAVE', // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId
              this.data.chgUserId = this.$store.getters.user.userId
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    removeProcess() {
      let msg = 'MSGREMOVE';
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',
        message: msg, // 삭제하시겠습니까?,
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.data.processCd);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.getSearchList();
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback(_result) {
      let _processCd = _result.data;
      if (this.saveType == 'POST') {
        this.$set(this.attachInfoL1Photo, 'taskKey', _processCd)
        this.$set(this.attachInfoL1Photo, 'isSubmit', uid())
        this.$set(this.attachInfoL1Hazard, 'taskKey', _processCd);
        this.$set(this.attachInfoL1Hazard, 'isSubmit', uid())
        this.$set(this.attachInfoL2Photo, 'taskKey', _processCd)
        this.$set(this.attachInfoL2Photo, 'isSubmit', uid())
      }
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getSearchList();
    },
    addParent() {
      this.attachable = true;
      this.saveable = true;
      this.deleteable = false;
      this.saveUrl = this.insertUrl;
      this.saveType = 'POST';
      this.updateMode = false;
      this.dataeditable = true;
      this.data = {
        plantCd: this.searchParam.plantCd,
        processCd: '',
        processNo: '',
        processName: '',
        upProcessCd: '',
        upProcessName: '',
        processLevelCd: '20',
        processDesc: '',
        managementDepts: '',
        orderNo: '',
        mainMaterial: '',
        workerCnt: '',
        productName: '',
        useFlag: 'Y',
        psmFlag: 'N',
        workCycleCd: null,
        workingTime: null,
        temperature: '',
      };
      this.$set(this.attachInfoL1Photo, 'taskKey', '')
      this.$set(this.attachInfoL1Hazard, 'taskKey', '');
    },
    addChild() {
      this.attachable = true;
      this.saveable = true;
      this.deleteable = false;
      this.saveUrl = this.insertUrl;
      this.saveType = 'POST';
      this.updateMode = false;
      this.dataeditable = true;
      this.data = {
        plantCd: this.selectedProcess.plantCd,
        processCd: '',
        processNo: '',
        processName: '',
        upProcessCd: this.selectedProcess.processCd,
        upProcessName: this.selectedProcess.processName,
        processLevelCd: '20',
        processDesc: '',
        managementDepts: '',
        orderNo: '',
        mainMaterial: '',
        workerCnt: '',
        productName: '',
        useFlag: 'Y',
        psmFlag: 'N',
        workCycleCd: null,
        workingTime: null,
        temperature: '',
      };
      this.$set(this.attachInfoL2Photo, 'taskKey', '');
    },
  }
};
</script>
